import _ from 'lodash'
import { styled } from 'styled-components'

import qs from 'qs'

import { LoadingContainer, ModelList, Pagination } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { EmptyModelState, Page } from 'core/components'
import { useQueryString } from 'core/hooks'
import { useLoanTapesList } from 'core/types'
import type { LoanTapesListVariables } from 'core/types/generated/loantapes/operations'
import { useState } from 'react'

// List view (mirrors WorkflowTypes list pattern) using generated hooks
const LoanTapes = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()
  const [page, setPage] = useState(1)

  const [query, setQuery] = useQueryString<
    NonNullable<LoanTapesListVariables['query']>
  >({ limit: 50, startingAfter: '', endingBefore: '' })

  const {
    data: loanTapes,
    isLoading,
    pagination,
  } = useLoanTapesList({ companyId, query })

  const nextToken = qs.parse((pagination as any)?.nextUrl ?? '')?.startingAfter
  const prevToken = qs.parse(
    (pagination as any)?.previousUrl ?? '',
  )?.endingBefore

  const sorted = _.orderBy(loanTapes as Array<any>, ['createdAt'], ['desc'])
  const grouped = _.groupBy(sorted, 'object')

  useClickAction({
    label: 'Create Loan Tape',
    onClick: () => history.push(`${url}/create`),
  })

  useClickAction({
    label: 'Generate Loan Tapes',
    onClick: () => history.push(`${url}/generate`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        {_.isEmpty(grouped) ? (
          <EmptyModelState
            heading='No loan tapes to display'
            subheading='There is no data for this list yet.'
          />
        ) : (
          _.map(grouped, (group, key) => (
            <ModelList json={group} key={key} title={String(key)} />
          ))
        )}

        <Box>
          <Pagination
            limit={query.limit ?? 0}
            onNext={() => {
              setQuery({
                ...query,
                startingAfter: nextToken,
                endingBefore: '',
              })
              setPage(page + 1)
            }}
            onPrevious={() => {
              setQuery({
                ...query,
                startingAfter: '',
                endingBefore: page > 2 ? prevToken : '',
              })
              setPage(page - 1)
            }}
            page={page}
            total={(pagination as any)?.total}
            variant='compact'
          />
        </Box>
      </Page>
    </LoadingContainer>
  )
}

export default LoanTapes

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
